import { comments } from '@/mocks/chiguaData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
            <i className="ri-chat-smile-2-line text-xl text-accent-600"></i>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              瓜友热评
            </h2>
            <p className="text-sm text-foreground-500 mt-0.5">看看大家都在说什么</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-sm font-bold">
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">
                    {comment.user}
                  </div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <button className="inline-flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </button>
                <button className="inline-flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
                <button className="inline-flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-share-forward-line"></i>
                  <span>分享</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}